import { render, staticRenderFns } from "./TicketDetailView.vue?vue&type=template&id=29ab84f0&scoped=true&"
import script from "./TicketDetailView.vue?vue&type=script&lang=ts&"
export * from "./TicketDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab84f0",
  null
  
)

export default component.exports